import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getReposRequest: [],
  getReposSuccess: ['data'],
  getReposFailure: ['error'],
});

export const ReposTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  repos: [],
  reposError: {},
});

/* Reducers */

const getReposRequest = (state) =>
  state.merge({
    ...state,
    reposError: {},
  });

const getReposSuccess = (state, { data }) =>
  state.merge({
    repos: data,
    reposError: {},
  });

const getReposFailure = (state, { error }) =>
  state.merge({
    ...state,
    reposError: { ...error },
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_REPOS_REQUEST]: getReposRequest,
  [Types.GET_REPOS_SUCCESS]: getReposSuccess,
  [Types.GET_REPOS_FAILURE]: getReposFailure,
});
